import Swiper from 'swiper';

class AgenceTeam {
  private component: NodeListOf<HTMLElement>;

  constructor() {
    this.component = document.querySelectorAll(
      '.agence-team__visu--a, .agence-team__visu--b, .agence-team__visu--c, .agence-team__visu--d'
    );

    if (this.component) {
      this.component.forEach((element: HTMLElement) => {
        (element?.firstElementChild as HTMLElement).style.transition =
          'transform 0.5s';
      });

      if (window.innerWidth > 1024) {
        this.applyParallaxEffect([-30, -25, -10, -40]); // large
      } else {
        this.applyParallaxEffect([0, -5, -2, -10]); // mobile
      }
    }
    this.initSwiper();
  }

  private initSwiper(): void {
    const elements = document.querySelectorAll(
      '[data-trigger="team-interactivite"]'
    );
    elements.forEach((element) => {
      const swiper = new Swiper(element as HTMLElement, {
        grabCursor: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        }
      });
      // Manually trigger slide change every 3 seconds
      setInterval(() => {
        if (swiper.isEnd) {
          swiper.slideTo(0);
        } else {
          swiper.slideNext();
        }
      }, 5000);
    });
  }

  applyParallaxEffect(speeds: number[]) {
    // apply a parallax effect on each image of the team section
    // listen to the scroll event and update the transform property of each image
    // use intersection observer to trigger the parallax effect only when the image is in the viewport
    this.component.forEach((img, index) => {
      this.createObserver(0, speeds[index], img);
    });
  }

  private createObserver(
    pourcent: number,
    speed: number,
    element: HTMLElement
  ) {
    const options = {
      rootMargin: '0px',
      threshold: pourcent / 100
    };
    const isIntersecting = (entry: IntersectionObserverEntry) =>
      entry.isIntersecting || entry.intersectionRatio > 0;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (isIntersecting(entry)) {
          this.startParallax(element, speed);
        } else {
        }
      });
    }, options);

    observer.observe(element);
  }

  private startParallax(element: HTMLElement, speed: number) {
    const initialPosition = window.pageYOffset;
    window.addEventListener('scroll', () => {
      const coef = (window.pageYOffset - initialPosition) * (speed / 100);
      element.style.transform = `translate3d(0, ${coef}px, 0)`;
    });
  }
}

const agenceTeam = new AgenceTeam();
